import { Injectable } from "@angular/core";
import { ApiService } from "@edp-services/api.service";
import { map } from "rxjs/operators";
import { EdpResponseBody } from "@edp-models/response.model";
import { IConsumptions } from "@edp-components/edp-card-widgets/edp-widget-conta-certa/edp-conta-certa.model";
import { Observable } from "rxjs";
import { IBankList } from "@edp-models/bank.model";
import { ConsentSubscription } from "@edp-models/consent.model";

@Injectable()
export class DashboardService {

    constructor(private apiService: ApiService) { }

    public getInvoices(contractId: string) {
        return this.apiService.callServicePostToCollection(`invoice.getInvoices`, {
            contractId
        });
    }

    public getContractRequest(contractId: string) {
        return this.apiService.callServicePostToCollection(`customerSupport.getContactsInAnalysis`, {
            contractId
        });
    }

    public getAccountBalance(contractId: string) {
        return this.apiService.callServicePostToCollection(`invoice.getAcountBalance`, {
            contractId
        });
    }

    public getAccountInvoice(contractId: string) {
        return this.apiService.callServicePostToCollection(`invoice.getAccountInvoiceList`, {
            contractId
        });
    }

    public getFunciona(contractId: string) {
        const body = {
            contractId
        };
        return this.apiService.callServicePost("contract.getFuncionaDetails", body).pipe(
            map((response: EdpResponseBody) => {
                return response.Result.Collection;
            })
        );
    }

    public getBanksList() {
        const body = {
            listType: "openbanking"
        };
        return this.apiService.callServicePostToCollection(`payment.getBanksList`, body);
    }

    public getCampaigns(partnerNumber: number, contractNumber: string) {
        return this.apiService.callServicePostToCollection("campaign.getDashboardWidget", {
            partnerNumber,
            contractNumber
        });
    }

    public getConsumptions(contractId: string): Observable<Error | IConsumptions> {
        return this.apiService.callServicePostToCollection<IConsumptions>(`reading.getConsumptions`, {
            contractId
        });
    }

    public insertBanks(bankList: IBankList[], contractId: string) {
        const body = {
            bankList,
            contractId
        };
        return this.apiService.callServicePostToCollection(`contract.insertBanksByContract`, body);
    }

    public deleteBank(bankId: number, contractId: string) {
        const body = {
            bankId,
            contractId
        };
        return this.apiService.callServicePostToCollection(`contract.deleteBankByContract`, body);
    }

    public consentSubscription(args: ConsentSubscription) {
        return this.apiService.callServicePost("campaign.setConsentAgreement", args);
    }
}
